import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CHECKOUT, ERROR, SUCCESS } from "../include/constant";
import { ratingAvg1 } from "../include/function";
import { getCustomer, setToLocalStorage } from "../include/function";
import { useNotification } from "../Toast/ToastProvider";
// import { useCart } from "../context/UserCartCountContext";
import { api, baseURL, customerReqConfig } from "../include/api";
import "../styles/Cart.css";
import { CircleX, SaveIcon, ShoppingCart, Trash } from "lucide-react";
import { loadCartData } from "../helper/cartUtils";

import { QuantityControl } from "../helper/QuantityControl";
import { useCart } from "./context/UserCartCountContext";

const OrderSummary = () => {
  const navigate = useNavigate();
  const toast = useNotification();
  const customer = getCustomer();
  const location = useLocation();
  // const { selectedAddress, billingAddress, gstNumber } = location.state || {};
  // console.log("address",selectedAddress);
  // console.log("billaddress", billingAddress);
  // console.log("gst", gstNumber);
  const orderAddresses = JSON.parse(
    localStorage.getItem("orderAddresses") || "{}"
  );
  const selectedAddress = orderAddresses.deliveryAddress;
  const selectedBillingAddress = orderAddresses.billingAddress;
  const selectedGstNo = orderAddresses.gstNumber;

  const { fetchCartCount } = useCart();
  const [allReviewData, setAllReviewData] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [placeOrderLoading, setPlaceOrderLoading] = useState(false);
  const [savedForLaterData, setSavedForLaterData] = useState({});
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(null);
  const [showSavedItemRemoveModal, setShowSavedItemRemoveModal] =
    useState(null);
  const [isBuyNowFlow, setIsBuyNowFlow] = useState(false);

  const fetchcart = () => {
    api
      .get("/cart/?customerId=" + customer.id, customerReqConfig())
      .then((response) => {
        if (response.status === 200 && response?.data?.data) {
          setCart(response.data.data);
        }
      })
      .catch(() => {
        // Do not force empty state here – let last known state remain
      });
  };
const handleIncreaseCount = (item) => {
  setLoading(item.productId);

  if (!cart[0] || !cart[0].cartItems) return;
  const cartItemIndex = cart[0].cartItems.findIndex(
    (c) => String(c.productId) === String(item.productId),
  );

  if (cartItemIndex === -1 || !cart[0].cartItems[cartItemIndex]) return;
  const currentItem = cart[0].cartItems[cartItemIndex];

  //BUY NOW FLOW: Update locally only (NO API CALL)
  if (isBuyNowFlow) {
    const updatedCart = [...cart];
    updatedCart[0].cartItems[cartItemIndex].qty += 1;

    // Recalculate totals
    const safeFloat = (val) => (isNaN(parseFloat(val)) ? 0 : parseFloat(val));

    const itemsPrice = updatedCart[0].cartItems.reduce(
      (sum, p) => sum + safeFloat(p.price) * parseInt(p.qty || 1),
      0,
    );

    const b2bDiscount = updatedCart[0].cartItems.reduce((sum, item) => {
      let d = 0;
      if (item.b2bDiscountMode === "percent") {
        d = Math.round(
          (safeFloat(item.b2bDiscountValue) / 100) *
            safeFloat(item.price) *
            parseInt(item.qty || 1),
        );
      } else if (item.b2bDiscountMode === "amount") {
        d = Math.round(
          safeFloat(item.b2bDiscountValue) * parseInt(item.qty || 1),
        );
      }
      return sum + d;
    }, 0);

    const b2cDiscount = updatedCart[0].cartItems.reduce((sum, item) => {
      let d = 0;
      if (item.b2cDiscountMode === "percent") {
        d = Math.round(
          (safeFloat(item.b2cDiscountValue) / 100) *
            safeFloat(item.price) *
            parseInt(item.qty || 1),
        );
      } else if (item.b2cDiscountMode === "amount") {
        d = Math.round(
          safeFloat(item.b2cDiscountValue) * parseInt(item.qty || 1),
        );
      }
      return sum + d;
    }, 0);

    const totalDiscountValue =
      !customer || customer.customerType === "individual"
        ? b2cDiscount
        : b2bDiscount;

    const totalDeliveryCharge = updatedCart[0].cartItems.reduce(
      (sum, p) => sum + safeFloat(p.deliveryCharge) * parseInt(p.qty || 1),
      0,
    );

    const totalPrice = itemsPrice - totalDiscountValue + totalDeliveryCharge;

    updatedCart[0].itemsPrice = itemsPrice;
    updatedCart[0].totalDiscountValue = totalDiscountValue;
    updatedCart[0].totalDeliveryCharge = totalDeliveryCharge;
    updatedCart[0].totalPrice = totalPrice;

    setCart(updatedCart);

    //Update localStorage too
    const checkoutData = JSON.parse(localStorage.getItem("checkout") || "{}");
    if (checkoutData && checkoutData.isBuyNow) {
      checkoutData.orderItems[cartItemIndex].qty += 1;
      checkoutData.billAmount = itemsPrice;
      checkoutData.totalDiscount = totalDiscountValue;
      checkoutData.totalDeliveryCharge = totalDeliveryCharge;
      checkoutData.totalAmount = totalPrice;
      localStorage.setItem("checkout", JSON.stringify(checkoutData));
    }

    setLoading(null);
    return;
  }

  //REGULAR CART FLOW: Existing API logic
  currentItem.qty = Number(currentItem.qty || 0) + 1;

  let productsDisValue = 0;
  if (item.discountMode === "percent") {
    productsDisValue +=
      (parseFloat(item.discountValue) / 100) * parseFloat(item.price);
  } else if (item.discountMode === "amount") {
    productsDisValue += parseFloat(item.discountValue);
  }

  const itemsPrice = Number(cart[0].itemsPrice) + parseFloat(item.price);
  const totalDiscountValue =
    parseFloat(cart[0].totalDiscountValue || 0) + productsDisValue;
  const totalDeliveryCharge = parseFloat(cart[0].totalDeliveryCharge || 0);

  const data = {
    customerId: cart[0].customerId,
    itemsPrice,
    totalDiscountValue,
    discountMode: item.discountMode,
    totalDeliveryCharge,
    totalPrice: itemsPrice - totalDiscountValue + totalDeliveryCharge,
    cartItems: [...cart[0].cartItems],
  };

  api
    .put(`/cart/?id=${cart[0].id}`, data, customerReqConfig())
    .then((response) => {
      if (response.status === 200) {
        toast({ type: SUCCESS, message: response.data.message });
        fetchcart();
        fetchCartCount();
      }
    })
    .catch((error) => {
      toast({
        type: ERROR,
        message: error.response?.data?.message || error.message,
      });
    })
    .finally(() => {
      setLoading(null);
    });
};
const handleDecreaseCount = (item) => {
  setLoading(item.productId);

  if (!cart[0] || !cart[0].cartItems) return;
  const cartItemIndex = cart[0].cartItems.findIndex(
    (c) => String(c.productId) === String(item.productId),
  );

  if (cartItemIndex === -1 || !cart[0].cartItems[cartItemIndex]) return;
  const currentItem = cart[0].cartItems[cartItemIndex];

  if (currentItem.qty <= 1) return;

  //BUY NOW FLOW: Update locally only (NO API CALL)
  if (isBuyNowFlow) {
    const updatedCart = [...cart];
    updatedCart[0].cartItems[cartItemIndex].qty -= 1;

    // Recalculate totals (same logic as handleIncreaseCount)
    const safeFloat = (val) => (isNaN(parseFloat(val)) ? 0 : parseFloat(val));

    const itemsPrice = updatedCart[0].cartItems.reduce(
      (sum, p) => sum + safeFloat(p.price) * parseInt(p.qty || 1),
      0,
    );

    const b2bDiscount = updatedCart[0].cartItems.reduce((sum, item) => {
      let d = 0;
      if (item.b2bDiscountMode === "percent") {
        d = Math.round(
          (safeFloat(item.b2bDiscountValue) / 100) *
            safeFloat(item.price) *
            parseInt(item.qty || 1),
        );
      } else if (item.b2bDiscountMode === "amount") {
        d = Math.round(
          safeFloat(item.b2bDiscountValue) * parseInt(item.qty || 1),
        );
      }
      return sum + d;
    }, 0);

    const b2cDiscount = updatedCart[0].cartItems.reduce((sum, item) => {
      let d = 0;
      if (item.b2cDiscountMode === "percent") {
        d = Math.round(
          (safeFloat(item.b2cDiscountValue) / 100) *
            safeFloat(item.price) *
            parseInt(item.qty || 1),
        );
      } else if (item.b2cDiscountMode === "amount") {
        d = Math.round(
          safeFloat(item.b2cDiscountValue) * parseInt(item.qty || 1),
        );
      }
      return sum + d;
    }, 0);

    const totalDiscountValue =
      !customer || customer.customerType === "individual"
        ? b2cDiscount
        : b2bDiscount;

    const totalDeliveryCharge = updatedCart[0].cartItems.reduce(
      (sum, p) => sum + safeFloat(p.deliveryCharge) * parseInt(p.qty || 1),
      0,
    );

    const totalPrice = itemsPrice - totalDiscountValue + totalDeliveryCharge;

    updatedCart[0].itemsPrice = itemsPrice;
    updatedCart[0].totalDiscountValue = totalDiscountValue;
    updatedCart[0].totalDeliveryCharge = totalDeliveryCharge;
    updatedCart[0].totalPrice = totalPrice;

    setCart(updatedCart);

    //Update localStorage too
    const checkoutData = JSON.parse(localStorage.getItem("checkout") || "{}");
    if (checkoutData && checkoutData.isBuyNow) {
      checkoutData.orderItems[cartItemIndex].qty -= 1;
      checkoutData.billAmount = itemsPrice;
      checkoutData.totalDiscount = totalDiscountValue;
      checkoutData.totalDeliveryCharge = totalDeliveryCharge;
      checkoutData.totalAmount = totalPrice;
      localStorage.setItem("checkout", JSON.stringify(checkoutData));
    }

    setLoading(null);
    return;
  }

  //REGULAR CART FLOW: Existing API logic
  currentItem.qty -= 1;

  let productsDisValue = 0;
  if (item.discountMode === "percent") {
    productsDisValue =
      (parseFloat(item.discountValue) / 100) * parseFloat(item.price);
  } else if (item.discountMode === "amount") {
    productsDisValue = parseFloat(item.discountValue);
  }

  const itemsPrice = Number(cart[0].itemsPrice) - parseFloat(item.price);
  const totalDiscountValue =
    parseFloat(cart[0].totalDiscountValue || 0) - productsDisValue;
  const totalDeliveryCharge = parseFloat(cart[0].totalDeliveryCharge || 0);

  const data = {
    customerId: cart[0].customerId,
    itemsPrice,
    totalDiscountValue,
    discountMode: cart[0].discountMode,
    totalDeliveryCharge,
    totalPrice: itemsPrice - totalDiscountValue + totalDeliveryCharge,
    cartItems: [...cart[0].cartItems],
  };

  api
    .put(`/cart/?id=${cart[0].id}`, data, customerReqConfig())
    .then((response) => {
      if (response.status === 200) {
        toast({ type: SUCCESS, message: response.data.message });
        fetchcart();
        fetchCartCount();
      }
    })
    .catch((error) => {
      toast({
        type: ERROR,
        message: error.response?.data?.message || error.message,
      });
    })
    .finally(() => {
      setLoading(null);
    });
};
  const handleRemoveItem = async (item) => {
    if (!cart || cart.length === 0) return;

    const updatedItems = cart[0].cartItems.filter(
      (c) => String(c.productId) !== String(item.productId)
    );

    const safeFloat = (val) => {
      const num = parseFloat(val);
      return isNaN(num) ? 0 : num;
    };

    if (updatedItems.length === 0) {
      // Optimistically clear local cart
      setCart([]);

      try {
        const response = await api.delete(
          `/cart/?id=${cart[0].id}`,
          customerReqConfig()
        );
        toast({ type: SUCCESS, message: response.data.message });

        // Refresh from backend just in case
        fetchcart();
        fetchCartCount();
      } catch (error) {
        toast({
          type: ERROR,
          message: error.response?.data?.message || error.message,
        });
        fetchcart(); // fallback
      } finally {
        setLoading(null);
      }
    } else {
      const itemsPrice = updatedItems.reduce(
        (sum, p) => sum + safeFloat(p.price) * parseInt(p.qty || 1),
        0
      );
    const b2bDiscount = updatedItems.reduce((sum, item) => {
    let d = 0;
    if (item.b2bDiscountMode === "percent") {
      d = Math.round(
        (safeFloat(item.b2bDiscountValue) / 100) *
        safeFloat(item.price) *
        parseInt(item.qty || 1)
      );
    } else if (item.b2bDiscountMode === "amount") {
      d = Math.round(safeFloat(item.b2bDiscountValue) * parseInt(item.qty || 1));
    }
    return sum + d;
  }, 0);
  const b2cDiscount = updatedItems.reduce((sum, item) => {
    let d = 0;
    if (item.b2cDiscountMode === "percent") {
      d = Math.round(
        (safeFloat(item.b2cDiscountValue) / 100) *
        safeFloat(item.price) *
        parseInt(item.qty || 1)
      );
    } else if (item.b2cDiscountMode === "amount") {
      d = Math.round(safeFloat(item.b2cDiscountValue) * parseInt(item.qty || 1));
    }
    return sum + d;
  }, 0);
      const totalDiscountValue =
        !customer || customer.customerType === "individual"
          ? b2cDiscount.toFixed(2)
          : b2bDiscount.toFixed(2);
      
      const totalDeliveryCharge = updatedItems.reduce(
        (sum, p) => sum + safeFloat(p.deliveryCharge) * parseInt(p.qty || 1),
        0
      );

      const updatedCart = {
        customerId: cart[0].customerId,
        itemsPrice,
        totalDiscountValue,
        discountMode: cart[0].discountMode,
        totalDeliveryCharge,
        totalPrice: itemsPrice - totalDiscountValue + totalDeliveryCharge,
        cartItems: updatedItems,
      };

      // Optimistically update UI
      setCart([updatedCart]);

      try {
        const response = await api.put(
          `/cart/?id=${cart[0].id}`,
          updatedCart,
          customerReqConfig()
        );
        toast({ type: SUCCESS, message: response.data.message });

        fetchcart(); // Just to confirm backend saved correctly
        fetchCartCount();
      } catch (error) {
        toast({
          type: ERROR,
          message: error.response?.data?.message || error.message,
        });
        fetchcart(); // fallback reload
      } finally {
        setLoading(null);
      }
    }
  };

useEffect(() => {
  const loadOrderData = () => {
    const checkoutData = JSON.parse(localStorage.getItem("checkout") || "{}");

    if (
      checkoutData &&
      checkoutData.isBuyNow &&
      checkoutData.orderItems?.length > 0
    ) {
      const fakeCart = [
        {
          id: "buynow-temp",
          customerId: customer.id,
          itemsPrice: checkoutData.billAmount || 0,
          totalDiscountValue: checkoutData.totalDiscount || 0,
          totalDeliveryCharge: checkoutData.totalDeliveryCharge || 0,
          totalPrice: checkoutData.totalAmount || 0,
          cartItems: checkoutData.orderItems.map((item) => ({
            productId: item.productId || item.id,
            qty: item.qty || 1,
            price: item.price || 0,
            discountMode: item.discountMode || "none",
            discountValue: item.discountValue || 0,
            deliveryCharge: item.deliveryCharge || 0,
            mainImage: item.mainImage || "",
            name: item.name || "Product",
            status: "active",
            shopStatus: "active",
            b2bDiscountMode: item.b2bDiscountMode || "none",
            b2bDiscountValue: item.b2bDiscountValue || 0,
            b2cDiscountMode: item.b2cDiscountMode || "none",
            b2cDiscountValue: item.b2cDiscountValue || 0,
          })),
        },
      ];

      setCart(fakeCart);
      setIsBuyNowFlow(true); //Mark as BuyNow flow
      setFetchLoading(false);
      return;
    }

    fetchcart();
    setIsBuyNowFlow(false); // Mark as Regular cart flow
  };

  if (customer?.id) {
    loadOrderData();
  } else {
    setFetchLoading(false);
  }
}, [customer?.id]);


  useEffect(() => {
    api
      .get("/rating_and_review/", customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setAllReviewData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching reviews:", error);
      });
  }, []);
  const handleCheckout = async () => {
    setLoading("checkout");
    let inactiveProducts = cart[0].cartItems.filter(
      (f) => f.status === "inactive" || f.shopStatus === "inactive"
    );
    if (inactiveProducts.length === 0) {
      const orderItems = cart[0].cartItems.map((item) => ({
        ...item,
        total: item.qty * item.price,
      }));
      const checkoutData = {
        totalItems: cart[0].cartItems.length,
        billAmount: cart[0].itemsPrice,
        totalDiscount: cart[0].totalDiscountValue,
        totalDeliveryCharge: cart[0].totalDeliveryCharge,
        totalAmount: cart[0].totalPrice,
        orderItems: orderItems,
      };
      setPlaceOrderLoading(true);
      await setToLocalStorage(CHECKOUT, checkoutData);
      setTimeout(() => {
        setPlaceOrderLoading(false);
        setLoading(null);
        navigate("/Checkout");
      }, 1000);
    } else {
      setLoading(null);
      toast({
        type: ERROR,
        message: "Please remove unavailable products from your cart",
      });
    }
  };
  const updateCartItemQtyLocally = (productId, newQty) => {
    setCart((prev) => {
      const updated = [...prev];
      if (updated[0] && updated[0].cartItems) {
        updated[0].cartItems = updated[0].cartItems.map((item) =>
          item.productId === productId ? { ...item, qty: newQty } : item
        );
      }
      return updated;
    });
  };

  const allCartItems = cart.flatMap((c) => c.cartItems || []);
  const safeFloat = (val) => (isNaN(parseFloat(val)) ? 0 : parseFloat(val));

   const b2bDiscount = allCartItems.reduce((sum, item) => {
     let d = 0;
     if (item.b2bDiscountMode === "percent") {
       d = Math.round(
         (safeFloat(item.b2bDiscountValue) / 100) *
           safeFloat(item.price) *
           parseInt(item.qty || 1)
       );
     } else if (item.b2bDiscountMode === "amount") {
       d = Math.round(
         safeFloat(item.b2bDiscountValue) * parseInt(item.qty || 1)
       );
     }
     return sum + d;
   }, 0);
   const b2cDiscount = allCartItems.reduce((sum, item) => {
     let d = 0;
     if (item.b2cDiscountMode === "percent") {
       d = Math.round(
         (safeFloat(item.b2cDiscountValue) / 100) *
           safeFloat(item.price) *
           parseInt(item.qty || 1)
       );
     } else if (item.b2cDiscountMode === "amount") {
       d = Math.round(
         safeFloat(item.b2cDiscountValue) * parseInt(item.qty || 1)
       );
     }
     return sum + d;
   }, 0);

  const delivery = allCartItems.reduce(
    (sum, item) =>
      sum + safeFloat(item.deliveryCharge) * parseInt(item.qty || 1),
    0
  );

  const totalMRP = allCartItems.reduce((sum, item) => {
    const price = parseInt(item.price || 0);
    const qty = parseInt(item.qty || 1);
    return sum + price * qty;
  }, 0);
  const totalDeliveryCharge = allCartItems.reduce((sum, item) => {
    const deliveryCharge = parseInt(item.deliveryCharge || 0);
    const qty = parseInt(item.qty || 1);
    return sum + deliveryCharge * qty;
  }, 0);

  //Cart Totals in subTotal
const discount =
  !customer || customer.customerType === "individual"
    ? b2cDiscount || 0
    : b2bDiscount || 0;
const subtotal = totalMRP - discount + totalDeliveryCharge;
  //Cart Totals in Total
  const grandTotal = subtotal;

  useEffect(() => {
    const handleCartUpdate = () => {
      loadCartData(customer.id);
    };
console.log("orderItems",allCartItems);

    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => window.removeEventListener("cartUpdated", handleCartUpdate);
  }, []);

 const [couponCode, setCouponCode] = useState("");
 const [couponError, setCouponError] = useState("");
 const [appliedCoupon, setAppliedCoupon] = useState(null);
 const [couponDiscount, setCouponDiscount] = useState(0);


const handleCouponCode = async () => {
  if (!couponCode.trim()) {
    setCouponError("Please enter a coupon code");
    return;
  }

  setCouponError("");

  try {
    const response = await api.get(
      `/voucher/?code=${encodeURIComponent(couponCode.trim())}`,
      customerReqConfig(),
    );

    if (response.status !== 200 || !response.data?.data?.[0]) {
      throw new Error("Invalid coupon code");
    }

    const rawCoupon = response.data.data[0];
    const coupon = {
      ...rawCoupon,
      category: Array.isArray(rawCoupon.category)
        ? rawCoupon.category
        : rawCoupon.category
            ?.toString()
            .split(",")
            .map((s) => s.trim()) || [],
      brand: Array.isArray(rawCoupon.brand)
        ? rawCoupon.brand
        : rawCoupon.brand
            ?.toString()
            .split(",")
            .map((s) => s.trim()) || [],
      product: Array.isArray(rawCoupon.product)
        ? rawCoupon.product
        : rawCoupon.product
            ?.toString()
            .split(",")
            .map((s) => s.trim()) || [],
      customer: Array.isArray(rawCoupon.customer)
        ? rawCoupon.customer
        : rawCoupon.customer
            ?.toString()
            .split(",")
            .map((s) => s.trim()) || [],
      customerGroup: Array.isArray(rawCoupon.customerGroup)
        ? rawCoupon.customerGroup
        : rawCoupon.customerGroup
            ?.toString()
            .split(",")
            .map((s) => s.trim()) || [],
      customerType: Array.isArray(rawCoupon.customerType)
        ? rawCoupon.customerType
        : rawCoupon.customerType
            ?.toString()
            .split(",")
            .map((s) => s.trim()) || [],
    };

    if (coupon.appliedCount >= coupon.maxCount) {
      throw new Error("Coupon usage limit reached");
    }

    const customerGroup =
      customer.customerType === "individual" ? "b2c" : "b2b";

    if (
      coupon.customerGroup?.length > 0 &&
      !coupon.customerGroup.includes(customerGroup)
    ) {
      throw new Error(`Coupon not valid for your customer group`);
    }

    if (
      coupon.customerType?.length > 0 &&
      !coupon.customerType.includes(customer.customerType)
    ) {
      throw new Error(`Coupon not valid for your customer type`);
    }

    if (
      coupon.customer?.length > 0 &&
      !coupon.customer.includes(String(customer.id))
    ) {
      throw new Error(`Coupon not valid for your account`);
    }

    const cartItems = cart[0]?.cartItems || [];
    let eligibleItems = [];
    let firstFailureReason = null;

    for (const item of cartItems) {
      try {
        // Product check
        if (coupon.product?.length > 0) {
          const matchesProduct = coupon.product.some(
            (p) => String(p).trim() === String(item.productId || "").trim(),
          );
          if (!matchesProduct) {
            throw new Error(
              `Coupon requires specific products: ${coupon.productName?.join(", ") || "specified products"}. Your item doesn't match.`,
            );
          }
        }

        // Brand check
        if (coupon.brand?.length > 0) {
          const matchesBrand = coupon.brand.some(
            (b) => String(b).trim() === String(item.brandId || "").trim(),
          );
          if (!matchesBrand) {
            throw new Error(
              `Coupon requires brand: ${coupon.brandName?.join(", ") || "specified brands"}. Your item has a different brand.`,
            ); 
          }
        }

        // Category check
        if (coupon.category?.length > 0) {
          const matchesCategory = coupon.category.some(
            (c) => String(c).trim() === String(item.categoryId || "").trim(),
          );
          if (!matchesCategory) {
            throw new Error(
              `Coupon applies only to category: ${coupon.categoryName?.join(", ") || "specified categories"}. Your item belongs to a different category.`,
            );
          }
        }

        eligibleItems.push(item);
      } catch (error) {
        if (!firstFailureReason) {
          firstFailureReason = error.message;
        }
      }
    }

    if (eligibleItems.length === 0) {
      throw new Error(
        firstFailureReason || "Coupon not applicable to any items in your cart",
      );
    }

    try {
      const usageCheckResponse = await api.post(
        "/voucher/?flag=verifyvoucher",
        {
          code: coupon.code,
          userId: customer.id,
        },
        customerReqConfig(),
      );

            if (!usageCheckResponse.status === 200) {
        const errorMessage =
          usageCheckResponse.data?.message ||
          usageCheckResponse.data?.error?.message ||
          "Coupon verification failed";

        throw new Error(errorMessage);
      }

    } catch (usageError) {
      const usageMessage =
        usageError.response?.data?.message ||
        usageError.response?.data?.error?.message ||
        usageError.message ||
        "Coupon cannot be applied";

      throw new Error(usageMessage);
    }
    const minReq = parseFloat(coupon.minRequirement || 0);
    const applicableAmount =
      coupon.basedOn === "quantity"
        ? eligibleItems.reduce((sum, item) => sum + parseInt(item.qty || 0), 0)
        : eligibleItems.reduce(
            (sum, item) =>
              sum + parseFloat(item.price || 0) * parseInt(item.qty || 1),
            0,
          );

    if (applicableAmount < minReq) {
      throw new Error(
        coupon.basedOn === "quantity"
          ? `Minimum ${minReq} quantity required`
          : `Minimum order value of ₹${minReq} required`,
      );
    }

    // Calculate discount
    let discount = 0;
    if (coupon.type === "percentage") {
      discount = (applicableAmount * parseFloat(coupon.value || 0)) / 100;
    } else if (coupon.type === "price") {
      discount = Math.min(parseFloat(coupon.value || 0), applicableAmount);
    }

    // const updatedCart = {
    //   ...cart[0],
    //   couponCode: coupon.code,
    //   couponDiscount: discount.toFixed(2),
    //   couponId: coupon.id,
    //   totalPrice: (parseFloat(cart[0].totalPrice || 0) - discount).toFixed(2),
    // };

    // await api.put(`/cart/?id=${cart[0].id}`, updatedCart, customerReqConfig());

    // STEP 9: Update UI
    setAppliedCoupon(coupon);
    setCouponDiscount(discount);
    setCouponError(null);
    fetchcart();

    toast({
      type: SUCCESS,
      message: `Coupon applied! ₹${discount.toFixed(2)} discount`,
    });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to apply coupon";

    setCouponError(errorMessage);
    toast({ type: ERROR, message: errorMessage });
  }
};

  console.log('couponDiscount',couponDiscount);
  



  return (
    <>
      {cart[0]?.cartItems?.length > 0 ? (
        <section className="cart py-48">
          <div className="container container-lg">
            {/* Checkout Progress Bar */}
            <div className="checkout-steps d-flex justify-content-center align-items-center mb-4 pb-48 px-80">
              <div className="step active">1</div>
              <div className="word">Cart</div>
              <div className="line active"></div>
              <div className="step active">2</div>
              <div className="word">Address</div>
              <div className="line active"></div>
              <div className="step active">3</div>
              <div className="word">Order Summary</div>
              <div className="line"></div>
              <div className="step">4</div>
              <div>Payment</div>
            </div>

            <div className="row gy-2">
              <div className="col-xl-9 col-lg-8">
                <div className="cart-table border border-gray-100 rounded-16 px-40 py-40">
                  <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                    <div className="d-flex justify-content-between">
                      <h6 className="text-xl mb-32 fw-bold">Order Summary</h6>
                      <h6 className="text-xl mb-32 fw-bold">{`${allCartItems.length} ITEMS`}</h6>
                    </div>
                    <div className="cart-items-list">
                      {cart.map((cart) =>
                        cart.cartItems.map((cartItem) => (
                          <CartItem
                            key={cartItem.productId}
                            cartItem={cartItem}
                            cart={cart}
                            handleIncreaseCount={handleIncreaseCount}
                            handleDecreaseCount={handleDecreaseCount}
                            handleRemoveItem={handleRemoveItem}
                            allReviewData={allReviewData}
                            fetchcart={fetchcart}
                            updateCartItemQtyLocally={updateCartItemQtyLocally}
                            loading={loading}
                            setLoading={setLoading}
                          />
                        )),
                      )}
                    </div>
                  </div>
                  <>
                    {selectedAddress ? (
                      <div className="mb-32">
                        <div className="d-flex justify-content-between align-items-start gap-10 p-16 border border-gray-100 rounded-8">
                          <div className="d-flex align-items-start gap-12">
                            <div
                              className="bg-gray-100 p-2 rounded-8 d-flex justify-content-center align-items-center"
                              style={{ width: "90px", height: "90px" }}
                            >
                              <i
                                className="ph ph-house"
                                style={{ fontSize: "60px" }}
                              />
                            </div>
                            <div>
                              <h6 className="text-dark fw-bold mb-1 fs-5">
                                Delivery Address
                              </h6>
                              <div style={{ width: "450px", textWrap: "wrap" }}>
                                <p className="mb-1">
                                  {selectedAddress.address}
                                </p>
                                <p className="mb-0">
                                  {selectedAddress.locality},{" "}
                                  {selectedAddress.city},{" "}
                                  {selectedAddress.state} -{" "}
                                  {selectedAddress.pin}
                                </p>
                              </div>
                            </div>
                          </div>
                          <button
                            className="btn btn-sm text-neutral-600 flex-center hover-bg-main-600 hover-text-white "
                            style={{
                              backgroundColor: "#ddd",
                              border: "none",
                            }}
                            onClick={() =>
                              navigate("/checkout", {
                                state: { selectedAddress },
                              })
                            }
                          >
                            Change
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="mb-32 text-warning">
                        No delivery address selected.
                      </div>
                    )}
                    {selectedBillingAddress ? (
                      <div className="mb-32">
                        <div className="d-flex justify-content-between align-items-start gap-10 p-16 border border-gray-100 rounded-8">
                          <div className="d-flex align-items-start gap-12">
                            <div
                              className="bg-gray-100 p-2 rounded-8 d-flex justify-content-center align-items-center"
                              style={{ width: "90px", height: "90px" }}
                            >
                              <i
                                className="ph ph-building"
                                style={{ fontSize: "60px" }}
                              />
                            </div>
                            <div>
                              <h6 className="text-dark fw-bold mb-1 fs-5">
                                Billing Address
                              </h6>
                              <div style={{ width: "450px", textWrap: "wrap" }}>
                                <p className="mb-1">
                                  {selectedBillingAddress.address}
                                </p>
                                <p className="mb-0">
                                  {selectedBillingAddress.locality},{" "}
                                  {selectedBillingAddress.city},{" "}
                                  {selectedBillingAddress.state} -{" "}
                                  {selectedBillingAddress.pin}
                                </p>
                              </div>
                            </div>
                          </div>
                          <button
                            className="btn btn-sm text-neutral-600 flex-center hover-bg-main-600 hover-text-white "
                            style={{
                              backgroundColor: "#ddd",
                              border: "none",
                            }}
                            onClick={() =>
                              navigate("/checkout", {
                                state: { selectedBillingAddress },
                              })
                            }
                          >
                            Change
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </>
                  <div>
                    <h6>Additional Notes:</h6>
                    <textarea
                      className="w-100 border-gray-100"
                      style={{
                        height: "20vh",
                        padding: "12px",
                        borderRadius: "8px",
                        fontFamily: "inherit",
                        fontSize: "1rem",
                      }}
                      placeholder="Write here..."
                    />
                  </div>
                  {/* GST Invoice Section */}
                  <div className="mt-24">
                    <div className="d-flex align-items-center gap-16">
                      {/* Checkbox */}
                      <div className="form-check d-flex align-items-center gap-10">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="gstInvoice"
                          defaultChecked 
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="gstInvoice"
                        >
                          <span className="fw-bold">GST Invoice</span>
                          <br />
                          <small className="text-gray-500">
                            {selectedGstNo}
                          </small>
                          <br />
                        </label>
                      </div>
                    </div>
                    <div className=" d-flex align-items-center gap-10">
                      <div className="align-items-center gap-10 mt-18">
                        <div className="flex-align gap-16">
                          <input
                            type="text"
                            className="common-input"
                            placeholder="Enter Coupon Code"
                            value={couponCode}
                            onChange={(e) => {
                              setCouponCode(e.target.value);
                              setCouponError("");
                              if (appliedCoupon) {
                                setAppliedCoupon(null);
                                setCouponDiscount(0);
                              }
                            }}
                            style={{ height: "40px", width: "200px" }} // ← FIXED HEIGHT
                          />
                          <button
                            type="button" // ← NOT "submit"
                            className="btn btn-main btn-sm rounded-5 px-24"
                            onClick={handleCouponCode}
                            disabled={!!appliedCoupon}
                            style={{ height: "40px" }}
                          >
                            {appliedCoupon ? "Applied" : "Apply"}
                          </button>
                        </div>

                        {couponError && (
                          <div
                            className="text-danger mt-2"
                            style={{ fontSize: "12px" }}
                          >
                            {couponError}
                          </div>
                        )}
                      </div>

                      {/* Proceed to Pay Button */}
                      <button
                        className="btn btn-main ms-auto"
                        onClick={() => navigate("/payment")}
                      >
                        Proceed to pay
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4">
                <div className="cart-sidebar border border-gray-100 rounded-16 px-24 py-40">
                  <h6 className="text-xl mb-32">PRICE DETAILS</h6>
                  <div className="bg-color-three rounded-8 p-24">
                    <div className="mb-32 flex-between gap-8">
                      <span className="text-gray-900 font-heading-two">
                        {`Price (${allCartItems.length}) items`}
                      </span>
                      <span className="text-gray-900 fw-semibold">
                        ₹ {totalMRP.toFixed(2)}
                      </span>
                      {/* <span className="text-gray-900 font-heading-two">
                        Total M.R.P
                      </span>
                      <span className="text-gray-900 fw-semibold">
                        ₹ {totalMRP.toFixed(2)}
                      </span> */}
                    </div>
                    <div className="mb-32 flex-between gap-8">
                      <span className="text-gray-900 font-heading-two">
                        Discount
                      </span>
                      <span className="text-gray-900 fw-semibold">
                        - ₹ {discount.toFixed(2)}
                      </span>
                    </div>
                    <div className="mb-32 flex-between gap-8">
                      <span className="text-gray-900 font-heading-two">
                        Coupon Discount
                      </span>
                      <span className="text-gray-900 fw-semibold">
                        {/* - ₹ {discount.toFixed(2)} */}- ₹ 0.00
                      </span>
                    </div>
                    <div className="mb-32 flex-between gap-8">
                      <span className="text-gray-900  fw-bold">
                        Delivery Charge
                      </span>
                      <span className="text-gray-900  fw-bold">
                        ₹{delivery.toFixed(2)}
                      </span>
                    </div>
                  </div>
                  <div className="bg-color-three rounded-8 p-24 mt-24">
                    <div className="flex-between gap-8">
                      <span className="text-gray-900 text-xl fw-bold">
                        Total
                      </span>
                      <span className="text-gray-900 text-xl fw-bold">
                        ₹ {grandTotal.toFixed(2)}
                      </span>
                    </div>
                  </div>
                  <div className="mt-68">
                    You will save ₹ {discount} on this order
                  </div>
                </div>
                <div className="mt-16 ms-16">
                  Your personal data will be used to process your order, support
                  your experience throughout this website, and for other purpose
                  described in our{" "}
                  <a style={{ color: "#ff6600" }}>Privacy policy</a> .
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="cart py-80">
          <div className="container container-lg text-center">
            <h3>Your Order Summary is empty</h3>
          </div>
        </section>
      )}
      {savedForLaterData?.products?.length > 0 && (
        <div className="row gy-2 px-16 mb-32">
          <div className="col-xl-9 col-lg-8">
            <div className="cart-table border border-gray-100 rounded-16 px-40 py-40">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <div className="d-flex justify-content-between">
                  <h6 className="text-xl mb-32 fw-bold">SAVED FOR LATER</h6>
                  <h6 className="text-xl mb-32 fw-bold">{`${savedForLaterData?.products?.length} ITEMS`}</h6>
                </div>
                <div className="cart-items-list">
                  {savedForLaterData.products.map((p, index) => {
                    const productReviews =
                      allReviewData?.filter((r) => r.productId === p.id) || [];
                    const discountUnitPrice =
                      p.discountMode === "percent"
                        ? parseFloat(p.price) -
                          (parseFloat(p.discountValue) / 100) *
                            parseFloat(p.price)
                        : parseFloat(p.price) - parseFloat(p.discountValue);

                    const subTotal = Math.round(discountUnitPrice).toFixed(2);

                    return (
                      <>
                        {showSavedItemRemoveModal && (
                          <div
                            className="modal-overlay"
                            onClick={() => setShowSavedItemRemoveModal(null)}
                          >
                            <div
                              className="modal-content"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span
                                onClick={() =>
                                  setShowSavedItemRemoveModal(null)
                                }
                                className="d-flex justify-content-end"
                              >
                                <CircleX color="#ddd" />
                              </span>
                              <h6 className="modal-header text-xl mb-16 fw-bold w-100 d-flex">
                                Remove Item
                              </h6>
                              <div className="modal-body">
                                <p
                                  style={{ color: "#aaa7a7ff" }}
                                  className="mb-40"
                                >
                                  Are you sure you want to remove this item?
                                </p>
                                {/* <div className="d-flex hstack gap-8">
                                  <button
                                    className="btn btn-main btn-sm rounded-5 py-16 fw-normal w-50"
                                    onClick={() => {
                                      handleRemoveItemFromSavedlist(
                                        showSavedItemRemoveModal.productId
                                      );
                                      setShowSavedItemRemoveModal(null);
                                    }}
                                  >
                                    REMOVE
                                  </button>
                                  <button
                                    className="btn btn-outline-main btn-sm rounded-5 py-16 fw-normal w-50"
                                    onClick={() =>
                                      setShowSavedItemRemoveModal(null)
                                    }
                                  >
                                    CANCEL
                                  </button>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="card cart-table border border-gray-100 rounded-16 mb-3 p-16">
                          <div className="row g-0">
                            {/* Product Image */}
                            <div
                              className="col-12 col-md-3 d-flex align-items-center justify-content-center rounded-16 p-3 mb-3 mb-md-0"
                              style={{
                                backgroundColor: "#F8F8F8",
                                width: "20%",
                              }}
                            >
                              <Link to={`/product-details/${p.id}`}>
                                <img
                                  src={baseURL + "/" + p.mainImage}
                                  alt={p.name}
                                  className="img-fluid rounded-8"
                                  style={{
                                    maxHeight: "120px",
                                    objectFit: "contain",
                                  }}
                                />
                              </Link>
                            </div>

                            {/* Product Details */}
                            <div className="col-12 col-md-6 border border-gray-100 border-start-0 border-md-start-0 border-end-1 border-top-0 border-bottom-0 border-md-end-0 p-0 mb-3 mb-md-0">
                              <div className="card-body d-flex flex-column h-100">
                                <div className="flex-grow-1">
                                  <h6 className="card-title text-md fw-bold mb-2">
                                    <Link
                                      to={`/product-details/${p.id}`}
                                      className="link text-line-2"
                                    >
                                      {p.name.toUpperCase()}
                                    </Link>
                                  </h6>

                                  {/* Reviews */}
                                  {productReviews.length > 0 && (
                                    <div className="flex-align gap-8 mb-2">
                                      <span className="fw-medium text-neutral-600">
                                        <div className="badge bg-success">
                                          {ratingAvg1(productReviews)}{" "}
                                          <i className="ph-fill ph-star" />
                                        </div>
                                      </span>
                                      <span className="fw-medium text-gray-500">
                                        ({productReviews.length})
                                      </span>
                                    </div>
                                  )}
                                  <br />
                                  {/* Price Details */}

                                  <div className="d-flex hstack gap-8">
                                    <div className="text-lg fw-bold">
                                      ₹{subTotal}
                                    </div>
                                    {p.discountValue > 0 && (
                                      <span
                                        className="text-sm"
                                        style={{ color: "#ff6600" }}
                                      >
                                        {p.discountLabel || "Discount"}
                                      </span>
                                    )}
                                  </div>

                                  <label className="text-sm fw-medium">
                                    {" "}
                                    {`M.R.P :\u00A0 `}
                                  </label>
                                  <span
                                    className="text-gray-500 text-md fw-bold"
                                    style={{ textDecoration: "line-through" }}
                                  >
                                    ₹ {parseFloat(p.price || 0).toFixed(2)}
                                  </span>
                                  <div className="text-gray-500 text-md fw-medium">
                                    Inclusive of all taxes
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-3 d-flex flex-column align-items-end ps-16">
                              {/* <div>
                                <button
                                  className="btn btn-sm text-neutral-600 flex-center hover-bg-main-600 hover-text-white mt-32 mb-16"
                                  style={{
                                    width: "200px",
                                    backgroundColor: "#ddd",
                                    border: "none",
                                  }}
                                  onClick={() => handleMoveToCart(p)}
                                  disabled={loading === p.id}
                                >
                                  {loading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      Adding...
                                    </>
                                  ) : (
                                    <>
                                      Add to Cart
                                      {`\u00A0\u00A0\u00A0`}
                                      <span>
                                        <ShoppingCart size={"20px"} />
                                      </span>
                                    </>
                                  )}
                                </button>
                              </div> */}

                              <div>
                                <button
                                  className="btn btn-sm text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
                                  style={{
                                    width: "200px",
                                    backgroundColor: "#ddd",
                                    border: "none",
                                  }}
                                  onClick={() => {
                                    setShowSavedItemRemoveModal({
                                      productId: p.id,
                                      name: p.name,
                                    });
                                  }}
                                  disabled={loading === p.id}
                                >
                                  {loading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      Removing...
                                    </>
                                  ) : (
                                    <>
                                      Reove
                                      {`\u00A0\u00A0\u00A0`}
                                      <span>
                                        <Trash size={"20px"} />
                                      </span>
                                    </>
                                  )}
                                </button>
                              </div>

                              {/* Subtotal */}
                              {/* <div className=" mt-2">
            <strong>Total: ₹{finalTotal}</strong>
          </div> */}
                            </div>
                          </div>
                        </div>
                        <style jsx global>
                          {`
                            .modal-overlay {
                              position: fixed;
                              top: 0;
                              left: 0;
                              right: 0;
                              bottom: 0;
                              background-color: rgba(0, 0, 0, 0.5);
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              z-index: 1000;
                            }
                            .modal-content {
                              background: white;
                              padding: 24px;
                              border-radius: 12px;
                              width: 90%;
                              max-width: 400px;
                              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                            }
                            .modal-header {
                              display: flex;
                              justify-content: space-between;
                              align-items: center;
                              margin-bottom: 16px;
                            }
                            .close-btn {
                              font-size: 24px;
                              cursor: pointer;
                              background: none;
                              border: none;
                              color: #666;
                            }
                            .modal-body {
                              text-align: center;
                            }
                            .btn {
                              padding: 8px 24px;
                              border-radius: 8px;
                              font-weight: bold;
                              cursor: pointer;
                            }
                            .btn-danger {
                              background-color: #ff6600;
                              color: white;
                            }
                            .btn-secondary {
                              background-color: #ddd;
                              color: black;
                            }
                            .ms-2 {
                              margin-left: 8px;
                            }
                          `}
                        </style>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderSummary;

const CartItem = ({
  cartItem,
  handleRemoveItem,
  allReviewData,
  fetchcart,
  cart,
  updateCartItemQtyLocally,
  loading,
  setLoading,
}) => {
  const [quantity, setQuantity] = useState(cartItem.qty);
  const [saveLaterLoading, setSaveLaterLoading] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(null); //New state

  const productReviews =
    allReviewData?.filter((r) => r.productId === cartItem.productId) || [];

  useEffect(() => {
    if (cartItem.qty !== quantity) {
      setQuantity(cartItem.qty);
    }
  }, [cartItem.qty, quantity]);

  const updateCartDirectly = (newQty) => {
    setLoading(cartItem.productId);
    api
      .get(`/cart/?customerId=${cart.customerId}`, customerReqConfig())
      .then((res) => {
        if (res.status === 200 && res.data?.data?.[0]) {
          const fetchedCart = res.data.data[0];
          const updatedItems = fetchedCart.cartItems.map((item) =>
            item.productId === cartItem.productId
              ? { ...cartItem, qty: newQty }
              : item
          );
          const safeFloat = (val) =>
            isNaN(parseFloat(val)) ? 0 : parseFloat(val);
          const itemsPrice = updatedItems.reduce(
            (sum, p) => sum + safeFloat(p.price) * parseInt(p.qty || 1),
            0
          );
          const totalDiscountValue = updatedItems.reduce((sum, p) => {
            let d = 0;
            if (p.discountMode === "percent") {
              d =
                (safeFloat(p.discountValue) / 100) *
                safeFloat(p.price) *
                parseInt(p.qty || 1);
            } else if (p.discountMode === "amount") {
              d = safeFloat(p.discountValue) * parseInt(p.qty || 1);
            }
            return sum + d;
          }, 0);
          const totalDeliveryCharge = updatedItems.reduce(
            (sum, p) =>
              sum + safeFloat(p.deliveryCharge) * parseInt(p.qty || 1),
            0
          );
          const totalPrice =
            itemsPrice - totalDiscountValue + totalDeliveryCharge;
          const payload = {
            customerId: fetchedCart.customerId,
            itemsPrice,
            totalDiscountValue,
            discountMode: fetchedCart.discountMode,
            totalDeliveryCharge,
            totalPrice,
            cartItems: updatedItems,
          };
          return api.put(
            `/cart/?id=${fetchedCart.id}`,
            payload,
            customerReqConfig()
          );
        }
      })
      .then(() => {
        fetchcart();
      })
      .catch((e) => {
        console.error("Qty update error", e);
      })
      .finally(() => {
        setLoading(null);
      });
  };

  const handleManualQtyChange = (newQty) => {
    if (newQty <= 0 || isNaN(newQty)) return;
    setQuantity(newQty);
    updateCartDirectly(newQty);
  };

  const incrementQuantity = () => {
    if (loading) return;
    setLoading(cartItem.productId);
    const newQty = quantity + 1;
    setQuantity(newQty);
    updateCartDirectly(newQty);
  };

  const decrementQuantity = () => {
    if (loading || quantity <= 1) return;
    setLoading(cartItem.productId);
    const newQty = quantity - 1;
    setQuantity(newQty);
    updateCartDirectly(newQty);
  };

  //Updated: Only show modal on click
  const removeItem = () => {
    setShowRemoveModal({
      productId: cartItem.productId,
      name: cartItem.name,
    });
  };

  const discountUnitPrice =
    cartItem.discountMode === "percent"
      ? parseFloat(cartItem.price) -
        (parseFloat(cartItem.discountValue) / 100) * parseFloat(cartItem.price)
      : parseFloat(cartItem.price) - parseFloat(cartItem.discountValue);
  const subTotal = Math.round(discountUnitPrice).toFixed(2);
  const finalTotal = Math.round(discountUnitPrice * parseInt(quantity)).toFixed(
    2
  );

  return (
    <div className="card cart-table border border-gray-100 rounded-16 px-1 py-16 mb-32">
      <div className="row g-0">
        {/* Product Image */}
        <div
          className="col-12 col-md-3 d-flex align-items-center justify-content-center rounded-16 p-3 mb-3 mb-md-0"
          style={{
            backgroundColor: "#F8F8F8",
            width: "20%",
            marginLeft: "20px",
          }}
        >
          <Link to={`/product-details/${cartItem.id}`}>
            <img
              src={baseURL + "/" + cartItem.mainImage}
              alt={cartItem.name}
              className="img-fluid rounded-8"
              style={{ maxHeight: "120px", objectFit: "contain" }}
            />
          </Link>
        </div>

        {/* Product Details */}
        <div className="col-12 col-md-6">
          <div className="card-body d-flex flex-column h-100">
            <div className="flex-grow-1">
              <h6 className="card-title text-md fw-bold mb-2">
                <Link
                  to={`/product-details/${cartItem.id}`}
                  className="link text-line-2"
                >
                  {cartItem.name.toUpperCase()}
                </Link>
              </h6>

              {/* Reviews */}
              {productReviews.length > 0 && (
                <div className="d-flex align-items-center gap-8 mb-2">
                  <span className="fw-medium text-neutral-600">
                    <div className="badge bg-success">
                      {ratingAvg1(productReviews)}{" "}
                      <i className="ph-fill ph-star" />
                    </div>
                  </span>
                  <span className="fw-medium text-gray-500">
                    ({productReviews.length})
                  </span>
                </div>
              )}
              <br />
              {/* Price Details */}
              <div className="d-flex hstack gap-8">
                <div className="text-lg fw-bold">₹{subTotal}</div>
                {cartItem.discountValue > 0 && (
                  <span className="text-sm" style={{ color: "#ff6600" }}>
                    {cartItem.discountLabel || "Discount"}
                  </span>
                )}
              </div>

              <label className="text-sm fw-medium"> {`M.R.P :\u00A0 `}</label>
              <span
                className="text-gray-500 text-md fw-bold"
                style={{ textDecoration: "line-through" }}
              >
                ₹ {parseFloat(cartItem.price || 0).toFixed(2)}
              </span>
              <div className="text-gray-500 text-md fw-medium">
                Inclusive of all taxes
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col-12 col-md-3 d-flex flex-column align-items-end ps-32"> */}
          {/* Quantity Control */}

          {/* <div className="w-100 mb-16">
            <QuantityControl
              quantity={quantity}
              setQuantity={handleManualQtyChange}
              incrementQuantity={incrementQuantity}
              decrementQuantity={decrementQuantity}
              buttonsDisabled={!!loading}
              isLoadingInc={loading === cartItem.productId}
              isLoadingDec={loading === cartItem.productId}
            />
          </div> */}
      
          {/* Remove Button */}

          {/* <div className="w-100">
            <button
              className="btn btn-sm text-neutral-600 flex-center hover-bg-main-600 hover-text-white w-100"
              style={{
                maxWidth: "200px",
                backgroundColor: "#ddd",
                border: "none",
              }}
              onClick={removeItem} // Only open modal
              disabled={saveLaterLoading || !!loading}
            >
              {saveLaterLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Removing...
                </>
              ) : (
                <>
                  Remove
                  {`\u00A0\u00A0\u00A0`}
                  <span>
                    <Trash size={"20px"} />
                  </span>
                </>
              )}
            </button>
          </div> */}

        {/* </div> */}

        {showRemoveModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowRemoveModal(null)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <span
                onClick={() => setShowRemoveModal(null)}
                className="d-flex justify-content-end"
              >
                <CircleX color="#ddd" />
              </span>
              <h6 className="modal-header text-xl mb-16 fw-bold w-100 d-flex">
                Remove Item
              </h6>

              <div className="modal-body">
                <p style={{ color: "#aaa7a7ff" }} className="mb-40">
                  Are you sure you want to remove this item?
                </p>

                <div className="d-flex hstack gap-8">
                  <button
                    className="btn btn-main btn-sm rounded-5 py-16 fw-normal w-50"
                    onClick={() => {
                      handleRemoveItem(cartItem);
                      setShowRemoveModal(null);
                    }}
                  >
                    REMOVE
                  </button>
                  <button
                    className="btn btn-outline-main btn-sm rounded-5 py-16 fw-normal w-50"
                    onClick={() => setShowRemoveModal(null)}
                  >
                    CANCEL
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ CSS */}
        <style jsx>{`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .modal-content {
            background: white;
            padding: 24px;
            border-radius: 12px;
            width: 90%;
            max-width: 400px;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          }
          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
          }
          .close-btn {
            font-size: 24px;
            cursor: pointer;
            background: none;
            border: none;
            color: #666;
          }
          .modal-body {
            text-align: center;
          }
          .btn {
            padding: 8px 24px;
            border-radius: 8px;
            font-weight: bold;
            cursor: pointer;
          }
          .btn-danger {
            background-color: #ff6600;
            color: white;
          }
          .btn-secondary {
            background-color: #ddd;
            color: black;
          }
          .ms-2 {
            margin-left: 8px;
          }
        `}</style>
      </div>
    </div>
  );
};
